<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  export default {
    mounted() {
      this.revertWindowClose();
    },
    methods: {
      revertWindowClose() {
        let iframe = document.createElement("iframe");
        iframe.style.display = "none";
        document.body.appendChild(iframe);
        let iframeWin = iframe.contentWindow;
        window.close = iframeWin.close;
        console.log("window.close", window.close);
      },
    },
  };
</script>
<style lang="less">
  #app {
    height: 100%;
    color: #2c3e50;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
